// removed by extract-text-webpack-plugin
module.exports = {"root":"FormTypeSelection__root___3iny9","button":"FormTypeSelection__button___3bHtm","login":"FormTypeSelection__login___bAy4e","register":"FormTypeSelection__register___3EyXx"};